<template>
  <div class="AnalysisCluster">
    <analysis-sidebar></analysis-sidebar>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Analysis/cluster.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <h2>CHIME FRB Analysis Cluster</h2>
    <b style="color:green">This page refreshes every minute.</b>
    <div class="text-center" id="welcome">
    </div>
    <b-container fluid>
    <b-card-group deck>
      <services
        title="All Services"
        :num="allServices.length"
        :clickHandler="this.showAllServices"
        ></services>
      <services
        title="Running"
        :num="running.length"
        :clickHandler="this.showRunningServices"></services>
      <services
        title="Rejected"
        :num="rejected.length"
        :clickHandler="this.showRejectedServices"></services>
      <services
        title="Shutdown"
        :num="shutdown.length"
        :clickHandler="this.showShutdownServices"></services>
      <services
        title="Failed"
        :num="failed.length"
        :clickHandler="this.showFailedServices"></services>
      <services
        title="Preparing"
        :num="preparing.length"
        :clickHandler="this.showPreparingServices"></services>
      <services
        title="Completed"
        :num="completed.length"
        :clickHandler="this.showCompletedServices"></services>
    </b-card-group>
    <b-row>
      <b-col md="6">
        <h4>Showing {{showingService}}</h4>
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search"/>
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
        <b-table show-empty
          :items="this.showServices"
          :fields="serviceFields"
          :small="smallTable"
          :filter="filter"
        >
          <template v-slot:cell(actions)="row">
            <b-button variant="outline-danger" size="sm" v-if="showKill && !row.item.isImmortal" @click="killJob(row.item, row.index, $event.target)">
              Kill
            </b-button>
            <b-button variant="outline-danger" size="sm" v-if="showPrune" @click="pruneJob(row.item, row.index, $event.target)">
              Prune
            </b-button>
            <b-button variant="dark" size="sm" @click="fetchLogs(row.item, row.index, $event.target)">
              Logs
            </b-button>
          </template>
        </b-table>
      </b-col>
      <b-col md="6">
        <b-form inline v-if="bulkPrune">
          <label style="color:red; font-size:150%" for="inline-form-input-name">Prune all jobs starting with the word: </label>
          <b-input
            id="inline-form-input-name"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="baseband"
            v-model="pruneRegex"
          ></b-input>
          <b-button @click="pruneAll()" variant="primary">Prune All</b-button>
        </b-form>
        <h3 id="logArea">Logs</h3>
        <b-table show-empty
          :responsive= true
          :items="logs"
          :fields="logFields"
          :small="smallTable"
          table-class="logTable"
          tr-class="logTable"
        >
        </b-table>
      </b-col>
    </b-row>
  </b-container>
  </div>
</template>
<style type="text/css">
.logTable>tbody>tr>td{
  font-size: 90%;
  font-weight: normal;
  font-family: sans-serif;
  background-color: black;
  color: orange;
  border: none;
}
</style>
<script>
import servicesCard from '../Outriggers/servicesCard'
import analysisSidebar from './analysisSidebar'
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
var serviceFields = [
  {key: 'serviceName', label: 'Service', sortable: true, 'class': 'text-left'},
  {key: 'status', label: 'Status', sortable: true, 'class': 'text-center'},
  {key: 'actions', label: 'Actions', 'class': 'text-right'}
]
var logFields = [
  // {key: 'date', label: 'Time', sortable: true, 'class': 'text-center'},
  // {key: 'logLevel', label: 'Log Level', sortable: true, 'class': 'text-center'},
  {key: 'logMsg', label: '', 'class': 'text-left'}
]
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      serviceFields: serviceFields,
      logFields: logFields,
      logName: '',
      userRole: 'MEMBER',
      bulkPrune: false,
      showPrune: false,
      showKill: false,
      pruneRegex: '',
      immortalServices: ['frb_master_app', 'website_app', 'distributor_app', 'rdb_secondary', 'rdb_primary', 'rdb_proxy', 'gather_filebeat', 'vis_dashboard', 'cadvisor_metrics', 'influx_db', 'elastic_master', 'elastic_kibana', 'elastic_ingest', 'elastic_data'],
      logs: [],
      showServices: [],
      showingService: '',
      allServices: [],
      running: [],
      rejected: [],
      shutdown: [],
      failed: [],
      completed: [],
      preparing: [],
      eventNum: null,
      plots: {},
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: 'id',
      plot: null,
      sortDesc: true,
      sortDirection: 'asc',
      filter: null
    }
  },
  mounted () {
    this.filter = this.$route.query.job
    this.fetchJobs()
    setInterval(this.fetchJobs, 60000)
    this.fetchLogsPeriodically()
    this.reloadTablePeriodically()
    this.showAllServices()
  },
  computed: {
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    showAllServices () {
      this.showServices = this.allServices
      this.showingService = 'all services'
      this.showKill = false
      this.showPrune = false
      this.bulkPrune = false
    },
    showRunningServices () {
      this.showServices = this.running
      this.showingService = 'running services'
      this.showKill = true
      this.showPrune = false
      this.bulkPrune = false
    },
    showRejectedServices () {
      this.showServices = this.rejected
      this.showingService = 'rejected services'
      this.showKill = true
      this.showPrune = false
      this.bulkPrune = false
    },
    showShutdownServices () {
      this.showServices = this.shutdown
      this.showingService = 'shutdown services'
      this.showKill = false
      this.showPrune = false
      this.bulkPrune = false
    },
    showPreparingServices () {
      this.showServices = this.preparing
      this.showingService = 'preparing services'
      this.showKill = true
      this.showPrune = false
      this.bulkPrune = false
    },
    showCompletedServices () {
      this.showServices = this.completed
      this.showingService = 'completed services'
      this.showPrune = true
      this.showKill = false
      this.bulkPrune = true
    },
    showFailedServices () {
      this.showServices = this.failed
      this.showingService = 'failed services'
      this.showPrune = false
      this.showKill = true
      this.bulkPrune = false
    },
    fetchJobs () {
      const url = 'https://frb.chimenet.ca/frb-master/v1/swarm/jobs'
      // this.refreshToken()
      // var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(url, {responseType: 'json'})
        .then(response => {
          this.parseJobs(response.body)
        })
    },
    killJob (evItem, index, button) {
      const url = 'https://frb.chimenet.ca/frb-master/v1/swarm/kill-job/' + evItem.serviceName
      this.refreshToken()
      // var authHeaders = {'Authorization': localStorage.accessToken}
      var conf = confirm('Are you sure you want to kill this service?')
      if (conf === true) {
        this.$http.get(url, {responseType: 'json'})
          .then(response => {
            alert(evItem.serviceName + ' Killed!')
            this.fetchJobs()
          })
      }
    },
    pruneAll () {
      var conf = confirm('Do you want to prune all jobs starting with ' + this.pruneRegex + ' ?')
      if (conf === true) {
        const url = 'https://frb.chimenet.ca/frb-master/v1/swarm/prune-job/' + this.pruneRegex
        // this.refreshToken()
        // var authHeaders = {'Authorization': localStorage.accessToken}
        this.$http.get(url, {responseType: 'json'})
          .then(response => {
            alert('Jobs containing ' + this.pruneRegex + ' Pruned!')
            this.fetchJobs()
          })
      }
    },
    pruneJob (evItem, index, button) {
      const url = 'https://frb.chimenet.ca/frb-master/v1/swarm/prune-job/' + evItem.serviceName
      this.refreshToken()
      // var authHeaders = {'Authorization': localStorage.accessToken}
      var conf = confirm('Are you sure you want to prunt this service?')
      if (conf === true) {
        this.$http.get(url, {responseType: 'json'})
          .then(response => {
            alert(evItem.serviceName + ' Pruned!')
            this.fetchJobs()
          })
      }
    },
    reloadTable () {
      if (this.showingService.includes('all')) {
        this.showAllServices()
      } else if (this.showingService.includes('failed')) {
        this.showFailedServices()
      } else if (this.showingService.includes('completed')) {
        this.showCompletedServices()
      } else if (this.showingService.includes('running')) {
        this.showRunningServices()
      } else if (this.showingService.includes('preparing')) {
        this.showPreparingServices()
      } else if (this.showingService.includes('shutdown')) {
        this.showShutdownServices()
      } else if (this.showingService.includes('rejected')) {
        this.showRejectedServices()
      } else {
        this.showServices = []
      }
    },
    fetchJobStatus (jobName) {
      const url = 'https://frb.chimenet.ca/frb-master/v1/swarm/full-job-status/' + jobName
      this.refreshToken()
      // var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(url, {responseType: 'json'})
        .then(response => {
          var item = {serviceName: jobName, status: response.body[jobName]}
          item['isImmortal'] = false
          item['numlines'] = 20
          if (this.immortalServices.includes(jobName)) {
            item['isImmortal'] = true
            item['numlines'] = 5
          }
          if (response.body[jobName].includes('running')) {
            item['status'] = 'running'
            item['_rowVariant'] = 'success'
            this.running.push(item)
          } else {
            if (response.body[jobName].includes('failed')) {
              item['_rowVariant'] = 'danger'
              item['status'] = 'failed'
              this.failed.push(item)
            } else if (response.body[jobName].includes('rejected')) {
              item['_rowVariant'] = 'dark'
              item['status'] = 'rejected'
              this.rejected.push(item)
            } else if (response.body[jobName].includes('shutdown')) {
              item['_rowVariant'] = 'info'
              item['status'] = 'shutdown'
              this.shutdown.push(item)
            } else if (response.body[jobName].includes('complete')) {
              item['_rowVariant'] = 'secondary'
              item['status'] = 'complete'
              this.completed.push(item)
            } else if (response.body[jobName].includes('preparing')) {
              item['_rowVariant'] = 'warning'
              item['status'] = 'preparing'
              this.preparing.push(item)
            }
          }
          this.allServices.push(item)
        })
    },
    parseJobs (myjobs) {
      this.allServices = []
      this.running = []
      this.rejected = []
      this.failed = []
      this.shutdown = []
      this.completed = []
      this.preparing = []
      for (var j = 0; j < myjobs.length; j++) {
        this.fetchJobStatus(myjobs[j])
      }
    },
    fetchLog () {
      if (Object.keys(this.logName).includes('serviceName') && Object.keys(this.logName).includes('numlines')) {
        const url = 'https://frb.chimenet.ca/frb-master/v1/swarm/logs/' + this.logName.serviceName + '?numlines=' + this.logName.numlines
        this.refreshToken()
        // var authHeaders = {'Authorization': localStorage.accessToken}
        this.$http.get(url, {responseType: 'json'})
          .then(response => {
            this.parseLogs(response.body[this.logName.serviceName])
            document.getElementById('logArea').innerHTML = 'Showing logs for ' + this.logName.serviceName
          }, error => {
            console.error(error)
            document.getElementById('logArea').innerHTML = 'No logs found for ' + this.logName.serviceName
          })
      }
    },
    reloadTablePeriodically () {
      setInterval(this.reloadTable, 500)
    },
    fetchLogsPeriodically () {
      setInterval(this.fetchLog, 10000)
    },
    fetchLogs (evItem, index, button) {
      this.logName = {serviceName: evItem.serviceName, numlines: evItem.numlines}
      document.getElementById('logArea').innerHTML = 'Fetching logs for ' + evItem.serviceName
      this.logs = []
      this.fetchLog()
    },
    parseLogs (logs) {
      if (logs === undefined) {
        this.logs = []
        document.getElementById('logArea').innerHTML = 'No logs found for ' + this.logName.serviceName
      } else {
        var logStr = logs
        var splitStr = logStr.split("b'")
        // this.logs = splitStr
        this.logs = []
        var line = ''
        var date = ''
        var logLevel = ''
        var logMsg = ''
        var splitLine = []
        for (var l = 0; l < splitStr.length; l++) {
          line = splitStr[l].split('\n')[0]
          line = line.slice(1, line.length - 3)
          splitLine = line.split(' ')
          date = '2' + splitLine[0]
          logLevel = splitLine[1]
          if (!['INFO', 'WARNING', 'ERROR', 'DEBUG', 'CRITICAL'].includes(logLevel)) {
            logLevel = ''
            logMsg = ''
            splitLine.slice(1, splitLine.length).forEach((ll) => {
              logMsg = logMsg + ' ' + ll
            })
          } else {
            logMsg = ''
            splitLine.slice(2, splitLine.length).forEach((ll) => {
              logMsg = logMsg + ' ' + ll
            })
          }
          if (line.length > 0) {
            logMsg = logMsg.trim()
            if (logMsg.length > 0) {
              this.logs.push({date, logMsg})
            }
          }
        }
        this.logs.sort(this.compare)
        this.logs = this.logs.splice(this.logs.length - 10, this.logs.length)
      }
    },
    compare (a, b) {
      if (a.date < b.date) {
        return -1
      }
      if (a.date > b.date) {
        return 1
      }
      return 0
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },
  components: {
    'services': servicesCard,
    'analysis-sidebar': analysisSidebar
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analysis/cluster.vue